import { SuperAdminService } from "services/superAdminService";

class EventsSAService extends SuperAdminService<any> {
  constructor() {
    super("events");
  }
}
export default new EventsSAService();
